app.service('deliveryShops', function (console, front, pageConfig, modal, saveDeliveryData) {
	var config; var savedCallback;

	function refresh(params, callback) {
		if(callback){
			savedCallback = callback;
		}
		var frontPlace = front.group();

		if (!config) {
			config = pageConfig.getData(frontPlace);
		}
		var data = {
			city: config.cityCode,
			store_code: config.shopCode,
			location: config.location,
			filtered: config.hasOnlySmall,
			lastOrderShopCode: config.lastOrderShopCode,
			orderNumber: config.orderNumber,
			taxfree: config.deliveryInfo && config.deliveryInfo.taxfree ? config.deliveryInfo.taxfree : undefined
		};

		$.extend(true, data, params);
		$.ajax({
			url: frontPlace == 'account' ? '/customer-order-select-shop.ltr' : '/orderSelectShop.ltr',
			method: 'get',
			data: data,
			success: function (html) {
				savedCallback(html, data, params);
			},
			error: function () {
				modal.alert('błąd pobierania danych, spróbuj ponownie.');
			}
		});
	}
	function refreshSuccess() {
		config.lastOrderShopCode = false;
		if ($('input[name="paymentType"][value="5"]:checked').length) {
			$('#shops-list').addClass('delivery-time-not-changeable');
		}
	}
	var savedShop = '';
	function selectCityParams(cityCode) {
		if (cityCode !== '') {
			savedShop = config.shopCode !== '' ? config.shopCode : savedShop;
			return {
				city: cityCode,
				store_code: savedShop
			};
		}
	}
	function findNearParams(position) {
		return {
			city: '',
			latitude: position.latitude,
			longitude: position.longitude
		};
	}
	function selectLocation(location) {
		console.log('WYBRANIE SKLEPU - ' + location.shop + ' | ' + location.city);
		if ($('#shop-code').length) {
			$('#shop-code').val(location.shop).valid();
		}
		if ($('#city-code').length) {
			$('#city-code').val(location.city).valid();
		}
		if($('#shop-delivery').length){
			if(config.shopCode == location.shop && config.cityCode == location.city){
				$('#container').addClass('hide-shops');
				$('#preview-order-steps .row-delivery-point').show();
				$.scrollTo($('.row-delivery-point'));
			} else {
				saveDeliveryData.send({
					pickupPointType: 'SHOP',
					pickupPointCode: location.shop,
					cityCode: location.city
				}, function(){
					config.shopCode = location.shop;
					config.cityCode = location.city;
					$('#container').addClass('hide-shops');
					$('#preview-order-steps .row-delivery-point').show();
					$.scrollTo($('.row-delivery-point'));
					refresh({
						lastOrderShopCode: false
					});
				});
			}
		} else {
			config.shopCode = location.shop;
			config.cityCode = location.city;
		}
	}

	return {
		refresh: refresh,
		refreshSuccess: refreshSuccess,
		selectCityParams: selectCityParams,
		findNearParams: findNearParams,
		selectLocation: selectLocation
	};
});
